import { Amplify } from 'aws-amplify'

Amplify.configure({
  auth: window.brandConfig.awsConfig.cognito,
  storage: window.sessionStorage,
})

export default Amplify
